import { create } from 'zustand'
import { createJSONStorage, persist } from 'zustand/middleware'

import { persistStorage } from '@/lib/storage'

interface TownState {
  /** Town slug, or null for "All towns" (BR-9). */
  town: string | null
  /** True when the town was picked from the shopper's location (BR-24), false when chosen by hand. */
  auto: boolean
  setTown: (slug: string | null, auto?: boolean) => void
}

export const useTownStore = create<TownState>()(
  persist(
    (set) => ({
      town: null,
      auto: false,
      setTown: (town, auto = false) => set({ town, auto }),
    }),
    { name: 'angadi.town', storage: createJSONStorage(() => persistStorage), version: 1 },
  ),
)
